export const SUBSCRIPTION_TIERS = {
  FREE: 'free',
  PREMIUM: 'premium',
  PRO: 'pro',
} as const;

// 👇 union of the object values
export type SubscriptionTier = typeof SUBSCRIPTION_TIERS[keyof typeof SUBSCRIPTION_TIERS];

export const DEFAULT_TIER: SubscriptionTier = SUBSCRIPTION_TIERS.FREE;

export function isSubscriptionTier(value: unknown): value is SubscriptionTier {
  return (
    typeof value === 'string' &&
    Object.values(SUBSCRIPTION_TIERS).includes(
      value as SubscriptionTier
    )
  );
}